import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './components/LoginScreen';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import ProfileScreen from './components/ProfileScreen';
import DutyAllotmentScreen from './components/DutyAllotmentScreen';
import LawajamHistoryScreen from './components/LawajamHistoryScreen';
import { ThemeProvider } from './contexts/ThemeContext';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  return <ThemeProvider data-id="element-0">
      <Router data-id="element-1">
        <div className="bg-gray-50 dark:bg-gray-900 min-h-screen" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/login" element={!isAuthenticated ? <LoginScreen onLogin={handleLogin} data-id="element-5" /> : <Navigate to="/" replace data-id="element-6" />} data-id="element-4" />
            <Route path="/" element={isAuthenticated ? <Layout data-id="element-8">
                    <Dashboard data-id="element-9" />
                  </Layout> : <Navigate to="/login" replace data-id="element-10" />} data-id="element-7" />
            <Route path="/profile" element={isAuthenticated ? <Layout data-id="element-12">
                    <ProfileScreen data-id="element-13" />
                  </Layout> : <Navigate to="/login" replace data-id="element-14" />} data-id="element-11" />
            <Route path="/duties" element={isAuthenticated ? <Layout data-id="element-16">
                    <DutyAllotmentScreen data-id="element-17" />
                  </Layout> : <Navigate to="/login" replace data-id="element-18" />} data-id="element-15" />
            <Route path="/lawajam" element={isAuthenticated ? <Layout data-id="element-20">
                    <LawajamHistoryScreen data-id="element-21" />
                  </Layout> : <Navigate to="/login" replace data-id="element-22" />} data-id="element-19" />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>;
}